import React from "react";

// PNG is now genuinely transparent. no mix-blend trick needed; it now sits
// cleanly on any background colour (light, tinted, or dark).
const LOGO_LIGHT = "/logo.png?v=7";

export function Logo({ size = 122, withWordmark = false, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="neuroeq-logo">
      <img src={LOGO_LIGHT} alt="NeuroEQ" width={size} height={size}
           style={{ width: size, height: "auto", objectFit: "contain" }} />
      {withWordmark && (
        <span className="font-display text-[hsl(var(--neu-orange))] text-4xl font-semibold tracking-tight">
          NeuroEQ
        </span>
      )}
    </div>
  );
}

export function Wordmark({ className = "" }) {
  return (
    <span className={`font-display text-[hsl(var(--neu-orange))] font-semibold ${className}`}>
      NeuroEQ
    </span>
  );
}
